import { Box } from '@lingoda/ui';
import { styled } from '@lingoda/ui/theme';

export const Footer = styled(Box)(({ theme }) => ({
    padding: theme.spacing(2),
    background: theme.palette.common.white,
    boxShadow: theme.shadows[3],
}));
